// Modules
import React, { CSSProperties } from "react";

// Interfaces
import Item from "Interfaces/ItemInterface";
import SelectedFilters from "Interfaces/SelectedFiltersInterface";

// Components
import MvCheckBox from "Generic/MvCheckBox";
import MvIcon from "Generic/MvIcon";
import { logAnalyticData, trackAnalyticData } from "Utils/analytics";

type Keys = 'plus' | 'minus' | 'home' | 'calendar' | 'x' | 'times' | 'exclamation';
type Props = {
  disabled?: boolean;
  displayName: string;
  items?: Item[];
  selected?: any;
  name: string;
  onSelect?: (name: string, value: string) => void;
  toggleOpen: (name: string) => void;
  opened: boolean;
  isAlternateSearchAvailable?: boolean;
};

type State = {
  isMobile: boolean;
};

class FilterResultsGroup extends React.Component<Props, State> {
  headerStyle: CSSProperties = {
    color: "rgb(2,150,136)",
    fontWeight: "bold",
    paddingTop: "10px",
    paddingBottom: "10px",
    position: "relative",
  
  };

  iconStyle: CSSProperties = {
    position: "absolute",
    right: "0px",
    top: "12px",
  };

  iconPlusStyle: CSSProperties = {
    right: "0px",
    top: "12px",
    fill: "var(--text-light-hyperlink, #008577)",
    height: "16px",
  };

  filterIconStyle: CSSProperties = {
    flex: "1 1 0",
    wordWrap: "break-word",
    fontFamily: "'Montserrat'",
    fontSize: "18px",
    fontWeight: 600,
    lineHeight: "28px",
  };
  disabled:CSSProperties = {
    color: "rgb(187,182,186)",
    fontWeight: "bold",
    paddingTop: "10px",
    paddingBottom: "10px",
    position: "relative"
  };
  constructor(props:Props) {
    super(props);
    this.toggleOpen = this.toggleOpen.bind(this);
    this.toggleOnSpace = this.toggleOnSpace.bind(this);
    this.selectOnSpace = this.selectOnSpace.bind(this);
    this.updateIsMobile = this.updateIsMobile.bind(this);
    this.state = {
      isMobile: typeof window !== "undefined" ? window.innerWidth <= 750 : false,
    };
  }
  componentDidMount() {
    this.updateIsMobile();
    window.addEventListener("resize", this.updateIsMobile);
  }
  componentWillUnmount() {
    window.removeEventListener("resize", this.updateIsMobile);
  }

  updateIsMobile() {
    const next = window.innerWidth <= 750;
    if (next !== this.state.isMobile) {
      this.setState({ isMobile: next });
    }
  }

  toggleOpen() {
    this.props.toggleOpen(this.props.name);
  }

  toggleOnSpace(event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.keyCode === 32) {
      event.preventDefault();
      this.props.toggleOpen(this.props.displayName);
    }
  }

  onSelect(item: Item) {
    if (this.props.onSelect) this.props.onSelect(this.props.name, item.value);
      console.log("aleternative search,",this.props.isAlternateSearchAvailable)

    logAnalyticData({ event: 'Search Resorts', siteSection: '', pageName:'Book My Holiday', website:'' }, {
      ownerActivity: '',
      step:'Step 2: Search Results 3',
      errorMessagfe:"",
      notificationType: "",
      customerID:"",
      searchCheckInDate: "", 
      alternativeSearchResorts:this.props.isAlternateSearchAvailable?"yes":"no",  
       
    })
    trackAnalyticData('points:step3');
  }

  selectOnSpace(item:Item, event: React.KeyboardEvent<HTMLDivElement>) {
    if (event.keyCode === 32) {
      event.preventDefault()
      if(this.props.onSelect)
      this.props.onSelect(this.props.name, item.value);
    }
  }

  noop() {}

  render() {
    const opened = !this.props.disabled && this.props.opened;

    let items;
    if (this.props.items) {
      items = this.props.items.map(item => {
        const isChecked = this.props.selected ? (this.props.selected.indexOf(item.value) > -1):false;
        const classNames = ["single-item"];

        // temp fix for room type, refer to room type pills for corresponding temp fix
        // const disabledForOnlyOneFix = this.props.name === 'roomType' && this.props.selected.length > 1 && !isChecked;

        // filter item disabled? - hack for disabling roomType filter
        // let itemDisabled = item.minimumPoints === 0 || disabledForOnlyOneFix;

        // Enabling filters fo rall conditions irrespective of minimumPoints. 
        // If minimumPoints needed then we have to uncomment the code.
        let itemDisabled = false;

        if (itemDisabled) classNames.push("disabled");

        return (
          <div key={item.value}
            className={classNames.join(" ")}
            tabIndex={this.props.disabled || itemDisabled ? -1 : 0}
            onKeyDown={(event) => this.selectOnSpace(item, event)}
            aria-checked={this.props.selected ? (this.props.selected.indexOf(item.value) > -1):false}
            role="checkbox">
            <MvCheckBox
              tabIndex={-1}
              label={item.description}
              id={item.value}
              checked={isChecked}
              onChange={() => {
                this.onSelect(item);
              }}
              disabled={this.props.disabled || itemDisabled}
            />
          </div>
        );
      });
    }
    let disabled = this.props.disabled;
    let callFunc = !disabled ? this.toggleOpen : this.noop;
    let style = !disabled ? this.headerStyle : this.disabled;
    let icon = opened ? "minus" : "plus";
    let content;
    if (this.props.children) {
      content = this.props.children;
    } else {
      content = <React.Fragment>{items}</React.Fragment>;
    }

    const iconStyle  = this.state.isMobile ? this.iconPlusStyle  : this.iconStyle;
    const spanTextSTyle = this.state.isMobile ? this.filterIconStyle : undefined; 

    return (
      <React.Fragment>
        <div
          style={style}
          onClick={callFunc}
          aria-label={this.props.displayName}
          aria-expanded={opened ? "true" : "false"}
          className="area-filter"
          tabIndex={this.props.disabled ? -1 : 0}
          role="button"
          onKeyDown={this.toggleOnSpace}
        >
          <span style={spanTextSTyle}>{this.props.displayName}</span>
          <MvIcon
            style={disabled ? {...iconStyle, opacity: 0.5, fill: "rgb(187, 182, 186)"} : iconStyle}
            height="16px"
            width="33px"
            icon={icon}
          />
        </div>
        {opened && <React.Fragment>{content}</React.Fragment>}
      </React.Fragment>
    );
  }
}
export default FilterResultsGroup;
